import { LOCALES } from "./locales";
import en from "./en.json";
import ru from "./ru.json";

export const messages = {
  [LOCALES.ENGLISH]: en,
  [LOCALES.RUSSIAN]: ru
}
